import type {FilteredItemsPageUrlQueryParams} from '../AdsModuleTypes'

// Локация, ключевые слова и категория не открывают пользовательскую сортировку.
export function shouldShowItemsListSorting(
    filters: FilteredItemsPageUrlQueryParams,
    categoryId?: string | number | null
): boolean {
    return (
        !!categoryId
        && categoryId !== ''
        && (
            Number(filters.minPrice) > 0
            || Number(filters.maxPrice) > 0
            || !!filters.cm
            || !!filters.f
        )
    )
}
